<template>
  <Select
    v-model="localValue"
    :items="items"
    v-bind="$attrs"
    :itemText="$attrs.itemText || 'key'"
    :itemValue="$attrs.itemValue || 'val'"
  >
    <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </Select>
</template>

<script>
import localValue from '@/mixins/localValue';

export default {
  mixins: [localValue],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    indexServiceAction: {
      type: Function,
      required: true,
    },
    indexServiceParams: {
      type: Object,
      default: () => ({}),
    },
    icon: {
      type: String,
      default: undefined,
    },
  },
  mounted() {
    this.getResults();
  },
  data() {
    return {
      items: [],
      meta: undefined,
      resultsReady: false,
      initialized: false,
    };
  },
  watch: {
    indexServiceParams: {
      deep: true,
      handler() {
        this.getResults();
      }
    },
    localValue: {
      immediate: true,
      handler(val) {
        if (!this.resultsReady) return;
        this.setSelectedObject(val);
      }
    },
  },
  methods: {
    setSelectedObject(val) {
      this.$emit('set', this.items.find(x => x.val == val));
      if (this.initialized) {
        this.$emit('change', this.items.find(x => x.val == val));
      } else {
        this.initialized = true;
        this.$emit('initialize', this.items.find(x => x.val == val));
      }
    },
    async getResults(offset=0) {
      try {
        const { data, meta } = await this.indexServiceAction({
          page: {
            limit: 100,
            offset: offset,
          },
          ...this.indexServiceParams,
        });
        this.meta = await meta;
        this.items = await this.items.concat(data.options);
      } catch (e) {
        console.log(e);
      } finally {
        if (this.meta?.recordCount && this.meta?.recordCount > this.items.length) {
          this.getResults(this.items.length);
        } else {
          this.resultsReady = true;
          this.setSelectedObject(this.localValue);
        }
      }
    }
  }
};
</script>
<style lang="css" scoped>
</style>
